export { mobileSortValueToSorting, sortingToMobileSortValue } from '../../../utils/mobileSortValue';

/** 手机订单列表排序（与 MRT 列 id / 后端 sortableFieldMap 一致） */
export const ORDER_LIST_MOBILE_SORT_OPTIONS = [
	{ value: 'createdAt:desc', label: '下单日期（新→旧）' },
	{ value: 'createdAt:asc', label: '下单日期（旧→新）' },
	{ value: 'completedAt:desc', label: '完成日期（新→旧）' },
	{ value: 'completedAt:asc', label: '完成日期（旧→新）' },
	{ value: 'orderId:asc', label: '订单编号（升序）' },
	{ value: 'orderId:desc', label: '订单编号（降序）' },
	{ value: 'currentAccountsReceivable:desc', label: '应收账款（高→低）' },
	{ value: 'currentAccountsReceivable:asc', label: '应收账款（低→高）' },
	{ value: 'customerInfo.customerName:asc', label: '客户名称（A→Z）' },
];
